(() => {
  const body = document.body;
  if (!body) return;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  requestAnimationFrame(() => {
    body.classList.add('wh198-page-ready');
    if (body.classList.contains('template-product') && !reduceMotion) {
      body.classList.add('wh198-entering');
      setTimeout(() => body.classList.remove('wh198-entering'), 900);
    }
  });

  if (reduceMotion) return;

  const isProductHref = (anchor) => {
    if (!anchor || !anchor.href) return false;
    try {
      const url = new URL(anchor.href, window.location.href);
      return url.origin === window.location.origin && /\/products\//.test(url.pathname);
    } catch (_) {
      return false;
    }
  };

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const anchor = event.target.closest('a[href]');
    if (!isProductHref(anchor) || anchor.target === '_blank' || anchor.hasAttribute('download')) return;

    const card = anchor.closest('.product-card-wrapper, .wh195-product-card');
    if (!card) return;

    event.preventDefault();
    card.classList.add('wh198-opening-card');
    body.classList.add('wh198-navigating');
    const destination = anchor.href;
    setTimeout(() => { window.location.href = destination; }, 300);
  }, { passive: false });

  window.addEventListener('pageshow', () => {
    body.classList.remove('wh198-navigating');
    document.querySelectorAll('.wh198-opening-card').forEach((node) => node.classList.remove('wh198-opening-card'));
  });
})();
